import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import topTitle from '@/components/title.vue';
import { insureDetailInfo, productionColumn } from '../utils';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    topTitle
  },
  props: ['data', 'baseInfo', 'status', 'visible'],
  data() {
    return {
      insureDetailInfo: recursionCopy(insureDetailInfo),
      columns: productionColumn,
      productionData: [],
      showForm: [],
      infoKeys: [{
        name: '保险信息',
        code: 'commonInfo'
      }, {
        name: '投保人信息',
        code: 'applicant'
      }, {
        name: '被保险人信息',
        code: 'insured'
      }]
    };
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.getDetail();
      }
    }
  },
  methods: {
    async getDetail() {
      var _this$data$commonInfo, _this$data$commonInfo2, _this$data$commonInfo3, _this$data$commonInfo4, _this$data$commonInfo5, _this$data$commonInfo6, _this$data$commonInfo8, _this$data$commonInfo0;
      this.showForm = [];
      this.productionData = [];
      this.insureDetailInfo = recursionCopy(insureDetailInfo);
      let obj = {
        name: (_this$data$commonInfo = this.data.commonInfo) === null || _this$data$commonInfo === void 0 ? void 0 : _this$data$commonInfo.insuranceName,
        type: '主险',
        planName: (_this$data$commonInfo2 = this.data.commonInfo) === null || _this$data$commonInfo2 === void 0 ? void 0 : _this$data$commonInfo2.insurancePlanName,
        areaName: ((_this$data$commonInfo3 = this.data.commonInfo) === null || _this$data$commonInfo3 === void 0 ? void 0 : _this$data$commonInfo3.areaName) || '',
        amount: (_this$data$commonInfo4 = this.data.commonInfo) === null || _this$data$commonInfo4 === void 0 ? void 0 : _this$data$commonInfo4.insurancePlanAmount
        // discountAmount: this.data.commonInfo?.discountAmount || ''
      };
      let price = (_this$data$commonInfo5 = this.data.commonInfo) !== null && _this$data$commonInfo5 !== void 0 && _this$data$commonInfo5.areaPrice ? this.data.commonInfo.areaPrice : this.data.commonInfo.price;
      obj.price = price;
      if (((_this$data$commonInfo6 = this.data.commonInfo) === null || _this$data$commonInfo6 === void 0 ? void 0 : _this$data$commonInfo6.discountMode) === 'ratio') {
        var _this$data$commonInfo7;
        obj.discountAmount = Number(Number(obj.price) * 100 - Number(obj.price) * 100 * Number(((_this$data$commonInfo7 = this.data.commonInfo) === null || _this$data$commonInfo7 === void 0 ? void 0 : _this$data$commonInfo7.discountRatio) / 100)) / 100;
      }
      if (((_this$data$commonInfo8 = this.data.commonInfo) === null || _this$data$commonInfo8 === void 0 ? void 0 : _this$data$commonInfo8.discountMode) === 'amount') {
        var _this$data$commonInfo9;
        obj.discountAmount = Number(Number(obj.price) * 100 - Number((_this$data$commonInfo9 = this.data.commonInfo) === null || _this$data$commonInfo9 === void 0 ? void 0 : _this$data$commonInfo9.discountAmount) * 100) / 100;
      }
      obj.discountAmount = obj.discountAmount > 0 ? parseFloat(obj.discountAmount).toFixed(2) : 0;
      this.productionData.push(obj);
      if ((_this$data$commonInfo0 = this.data.commonInfo) !== null && _this$data$commonInfo0 !== void 0 && (_this$data$commonInfo0 = _this$data$commonInfo0.attachInfo) !== null && _this$data$commonInfo0 !== void 0 && _this$data$commonInfo0.length) {
        this.data.commonInfo.attachInfo.forEach(item => {
          let _find = item.attachPlan.find(i => i.mark == item.mark);
          let obj = {
            name: item.name,
            type: '附加险',
            planName: (_find === null || _find === void 0 ? void 0 : _find.name) || '',
            price: (_find === null || _find === void 0 ? void 0 : _find.price) || '',
            amount: (_find === null || _find === void 0 ? void 0 : _find.amount) || ''
          };
          this.productionData.push(obj);
        });
      }
      for (const key in this.data) {
        let obj = {};
        const element = this.data[key];
        let _find = this.infoKeys.find(i => i.code == key);
        if (_find) {
          obj.name = _find.name;
          if (key == 'commonInfo') {
            obj.item = element.commonTemplate;
          } else {
            obj.item = element;
          }
          this.showForm.push(obj);
        }
      }
      if (this.status == '已投保' || this.status == '部分投保' || this.status == '投保失败') {
        this.insureDetailInfo.forEach((item, index) => {
          switch (item.key) {
            case 'policyStatus':
              this.insureDetailInfo[index].value = this.baseInfo.policyStatus;
              break;
            case 'infoCreateAt':
              this.insureDetailInfo[index].value = this.baseInfo.infoCreateAt;
              break;
            case 'policyNo':
              this.insureDetailInfo[index].value = this.baseInfo.policyNo;
              break;
            case 'createAt':
              this.insureDetailInfo[index].value = this.baseInfo.createAt;
              break;
            case 'orderNo':
              this.insureDetailInfo[index].value = this.baseInfo.orderNo;
              break;
            case 'paymentAt':
              this.insureDetailInfo[index].value = this.baseInfo.paymentAt;
              break;
            default:
              break;
          }
        });
      }
    }
  }
};